import { Link } from "@tanstack/react-router";

const cities = [
  { slug: "elektriker-koebenhavn", label: "København" },
  { slug: "elektriker-oesterbro", label: "Østerbro" },
  { slug: "elektriker-norrebro", label: "Nørrebro" },
  { slug: "elektriker-vesterbro", label: "Vesterbro" },
  { slug: "elektriker-indre-by", label: "Indre By" },
  { slug: "elektriker-frederiksberg", label: "Frederiksberg" },
  { slug: "elektriker-hellerup", label: "Hellerup" },
  { slug: "elektriker-charlottenlund", label: "Charlottenlund" },
  { slug: "elektriker-gentofte", label: "Gentofte" },
  { slug: "elektriker-gladsaxe", label: "Gladsaxe" },
  { slug: "elektriker-valby", label: "Valby" },
  { slug: "elektriker-vanloese", label: "Vanløse" },
  { slug: "elektriker-amager", label: "Amager" },
  { slug: "elektriker-lyngby", label: "Lyngby" },
  { slug: "elektriker-nordsjaelland", label: "Nordsjælland" },
];

export function CoveragePills() {
  return (
    <div>
      <h2 className="text-xl font-bold text-[var(--ink)] md:text-2xl">Hvor har du brug for en elektriker?</h2>
      <p className="mt-2 text-sm text-muted-foreground">
        Vi kører i hele Storkøbenhavn. Vælg dit område og se hvad vi kan hjælpe med.
      </p>
      <div className="mt-4 flex flex-wrap gap-2">
        {cities.map((c) => (
          <Link
            key={c.slug}
            to={`/${c.slug}` as string}
            className="rounded-full border border-border bg-card px-4 py-1.5 text-sm font-medium text-[var(--ink)] transition hover:border-primary/60 hover:bg-accent hover:shadow-[var(--shadow-soft)]"
          >
            {c.label}
          </Link>
        ))}
        <Link
          to="/byer"
          className="rounded-full border border-border bg-card px-4 py-1.5 text-sm font-medium text-muted-foreground transition hover:border-primary/60 hover:bg-accent"
        >
          + flere →
        </Link>
      </div>
    </div>
  );
}

export function CoverageBanner() {
  return (
    <section className="relative overflow-hidden border-y border-border">
      <div aria-hidden className="absolute inset-0 -z-10 opacity-40" style={{ background: "radial-gradient(50% 60% at 50% 0%, color-mix(in oklab, var(--brand) 12%, transparent), transparent 60%)" }} />
      <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 sm:py-14 lg:px-8">
        <div className="flex flex-col items-center gap-6 text-center md:flex-row md:justify-between md:text-left">
          <div className="max-w-md">
            <h2 className="text-xl font-bold text-[var(--ink)] md:text-2xl">Hvor har du brug for en elektriker?</h2>
            <p className="mt-2 text-sm text-muted-foreground">
              Vi kører i hele Storkøbenhavn. Vælg dit område og se hvad vi kan hjælpe med.
            </p>
          </div>
          <div className="flex flex-wrap justify-center gap-2 md:justify-end md:max-w-lg">
            {cities.map((c) => (
              <Link
                key={c.slug}
                to={`/${c.slug}` as string}
                className="rounded-full border border-border bg-card px-4 py-1.5 text-sm font-medium text-[var(--ink)] transition hover:border-primary/60 hover:bg-accent hover:shadow-[var(--shadow-soft)]"
              >
                {c.label}
              </Link>
            ))}
            <Link
              to="/byer"
              className="rounded-full border border-border bg-card px-4 py-1.5 text-sm font-medium text-muted-foreground transition hover:border-primary/60 hover:bg-accent"
            >
              + flere →
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
